<div class="container">
    <ng-template id="nodes" #nodes>
    </ng-template>
</div>
<div>
    <button clasa="align-middle" (click)="saveNodeJson()">Save Flow Node JSON</button>
</div>